//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Object.js";
import "../GeometricAnalysis/GeometricAnalysis.AnalysisObjectCollection.js";
let d=[[],[[["radiusAO"],"CreateRadiusAnalysisBuilder",{R_:{radiusBuilder:"GeometricAnalysis.RadiusAnalysisBuilder"}},1,1],[["slopeAO"],"CreateSlopeAnalysisBuilder",{R_:{slopeBuilder:"GeometricAnalysis.SlopeAnalysisBuilder"}},1,1],[["distanceAO"],"CreateDistanceAnalysisBuilder",{R_:{distanceBuilder:"GeometricAnalysis.DistanceAnalysisBuilder"}},1,1],[["reflectionAO"],"CreateReflectionAnalysisBuilder",{R_:{reflectionBuilder:"GeometricAnalysis.ReflectionAnalysisBuilder"}},1,1],[["sheetBoundaryAnalysisAO"],"CreateSheetBoundaryAnalysisBuilder",{R_:{sheetBoundaryBuilder:"GeometricAnalysis.SheetBoundaryAnalysisBuilder"}},1,0],[["perfPredictAO"],"CreatePerformancePredictorBuilder",{R_:{perfPredictBuilder:"GeometricAnalysis.PerformancePredictorBuilder"}},1,0],[["fileNameAndPath"],"CreatePerformancePredictorFromJsonFile",{R_:{perfPredicAO:"GeometricAnalysis.PerformancePredictor"}},1,0],[["distanceAO"],"CreateDistanceAnalysisBuilder1",{R_:{distanceBuilder:"GeometricAnalysis.DistanceAnalysisBuilder1"}},1,0],[["slopeAO"],"CreateSlopeAnalysisBuilder1",{R_:{slopeBuilder:"GeometricAnalysis.SlopeAnalysisBuilder1"}},1,0],[["reflectionAO"],"CreateReflectionAnalysisBuilder1",{R_:{reflectionBuilder:"GeometricAnalysis.ReflectionAnalysisBuilder1"}},1,0],[["radiusAO"],"CreateRadiusAnalysisBuilder1",{R_:{radiusBuilder:"GeometricAnalysis.RadiusAnalysisBuilder1"}},1,0]],[]];
SPLM.GeometricAnalysis.AnalysisObjectCollectionEx = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.GeometricAnalysis.AnalysisObjectCollectionEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;